/** @format */

import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageSquare, ArrowRight } from "lucide-react"; // Added/Refined Icons

const ContactBlock = ({
	title = "Need Assistance?", // Default title
	description = "Our window treatment experts are ready to help with any questions you have.", // Default description
	ctaText = "Contact Our Experts", // Default CTA text
	ctaIcon: CtaIcon = Phone, // Default icon, allow override
	className = "",
}) => {
	// Animation variant for the main content
	const contentVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5, ease: "easeOut" },
		},
	};

	return (
		// Use a section tag, add top margin, subtle background, border top for separation
		<section
			className={`mt-16 md:mt-24 py-16 md:py-20 bg-gradient-to-r from-gray-50 via-white to-gray-50 border-t border-gray-200 ${className}`}
		>
			<div className="container mx-auto px-4">
				<motion.div
					className="max-w-3xl mx-auto text-center"
					variants={contentVariants}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true, amount: 0.3 }} // Trigger when 30% visible
				>
					{/* Optional Icon Above Title */}
					{/* <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4">
                        <MessageSquare size={28} strokeWidth={1.5} />
                    </div> */}

					{/* Title */}
					<h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4">
						{title}
					</h2>
					{/* Description */}
					<p className="text-base md:text-lg text-gray-600 mb-8 max-w-xl mx-auto">
						{description}
					</p>

					{/* Call to Action Link (Styled as Button) */}
					{/* The entire element is now the Link */}
					<Link
						to="/contact" // Direct link to contact page
						className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-lg font-semibold shadow-md hover:bg-primary/90 transition-all duration-200 group text-base focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-2" // Using btn styles directly
					>
						<CtaIcon className="w-5 h-5" />
						<span>{ctaText}</span>
						{/* Simple arrow indicating action, moves on group hover */}
						<ArrowRight className="w-5 h-5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" />
					</Link>

					{/* Optional: Add a small reassurance text below */}
					<p className="text-xs text-gray-500 mt-4">
						We're here to help you find the perfect solution.
					</p>
				</motion.div>
			</div>
		</section>
	);
};

export default ContactBlock;
